<template>
  <div class="wrap">
    <div class="wrap__illustration">
      404
    </div>

    <div class="wrap__content">
      <h2>Page not found</h2>
      <p>We are very sorry for your inconvenience. It looks you are trying to access a page that either has been deleted or never existed.</p>

      <UtilityCtaButton
        class="wrap__button"
        size="md"
        icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3.222 18.917c5.666-5.905-.629-10.828-5.011-7.706l1.789 1.789h-6v-6l1.832 1.832c7.846-6.07 16.212 4.479 7.39 10.085z"/></svg>'
        :round="true"
        variant="dotted"
        color="transparent"
        @click="toHome()"
      >
        Back to home
      </UtilityCtaButton>
    </div>
  </div>
</template>

<script>
import FormButton from '@/components/form/Button.vue'
import UtilityCtaButton from '@/components/utility/CtaButton.vue'
import helperMethods from '@/helpers/utility.js'

export default {
  components: {
    FormButton,
    UtilityCtaButton
  },
  metaInfo () {
    return {
      title: 'Page not found'
    }
  },
  methods: {
    toHome () {
      this.sendGoogleAnalyticsEvent('misc_click', '404_toHome', this.$route.name, this.$store.getters['user/getSubscriptionStatus'])
      this.$router.push('/')
    },
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: $xlContentWidth;
  height: auto;
  min-height: 50vh;
  margin: 144px auto 464px auto;
  text-align: center;

  @media screen and (min-width: $breakpointSm) {
    width: calc(100% - 32px);
    margin: 100px auto 464px auto;
  }

  @media screen and (min-width: $breakpointMd) {
    flex-direction: row;
    text-align: left;
  }

  @media screen and (min-width: $breakpointLg) {
    margin: 108px auto 464px auto;
  }

  h2 {
    @include font('header--xxl', $white, 0.9);
    margin: 0 0 1rem 0;
    text-transform: uppercase;
  }

  p {
    @include font('content--lg', $white, 0.9);
    line-height: 1.5rem;
    font-weight: 500;
    margin: 0 0 2rem 0;
  }

  &__illustration {
    @include font('content--md', $white);
    width: 100%;
    max-width: 400px;
    margin: 3rem 1rem;
    font-size: 200px;
    font-weight: 700;
    text-shadow: rgba($black, 0.5) 3px 4px;
    opacity: 0.1;
    user-select: none;
    display: none;

    @media screen and (min-width: $breakpointMd) {
      margin: 2rem;
      display: block;
    }
  }

  &__content {
    width: 100%;
    max-width: 400px;
    margin: 3rem 1rem;

    @media screen and (min-width: $breakpointMd) {
      margin: 2rem;
    }
  }

  &__button {
    @media screen and (min-width: $breakpointMd) {
      float: left;
    }
  }
}

</style>
